(function () {
  function renderCard(container, product) {
    const price = (product.price / 100).toFixed(2).replace('.', ',');
    container.innerHTML = `
      <p class="endless-cross-sell__heading">Complète ton outfit</p>
      <div class="endless-cross-sell__card">
        <a href="${product.url}" class="endless-cross-sell__image">
          <img src="${product.featured_image}" alt="${product.title}" width="60" height="60" loading="lazy">
        </a>
        <div class="endless-cross-sell__info">
          <a href="${product.url}" class="endless-cross-sell__title">${product.title}</a>
          <span class="endless-cross-sell__price">${price}&nbsp;€</span>
        </div>
        <a href="${product.url}" class="endless-cross-sell__button">Ajouter</a>
      </div>
    `;
    container.hidden = false;
  }

  function renderCrossSell() {
    const container = document.getElementById('endless-cart-cross-sell');
    if (!container) return;

    const firstProductId = container.dataset.firstProductId;
    if (!firstProductId) {
      container.hidden = true;
      return;
    }

    const cartProductIds = (container.dataset.cartProductIds || '')
      .split(',')
      .filter(Boolean);

    fetch(`/recommendations/products.json?product_id=${firstProductId}&intent=complementary&limit=6`)
      .then((response) => response.json())
      .then((data) => {
        const candidate = (data.products || []).find(
          (product) => !cartProductIds.includes(String(product.id))
        );
        if (candidate) {
          renderCard(container, candidate);
        } else {
          container.hidden = true;
        }
      })
      .catch(() => {
        container.hidden = true;
      });
  }

  renderCrossSell();

  let lastContainer = document.getElementById('endless-cart-cross-sell');
  const observer = new MutationObserver(() => {
    const currentContainer = document.getElementById('endless-cart-cross-sell');
    if (currentContainer && currentContainer !== lastContainer) {
      lastContainer = currentContainer;
      renderCrossSell();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();